import { templateJoin } from 'bernie-graphql';

    export const addPropertyToCartQuery = templateJoin`
        mutation AddPropertyToCart($id: UUID!, $context: ContextInput!, $propertyOffer: PropertyOfferInput!, $cartPropertySearchContextInput: CartPropertySearchContextInput!){
    cartItems(
        id: $id, context: $context
    ) {
        addProperty(key: $propertyOffer, searchContext: $cartPropertySearchContextInput) {
            id
            itemCount
        }
    }
}

    `;

    export const createMultiItemSessionQuery = templateJoin`
        mutation CreateMultiItemSession($context: ContextInput! $multiItemSearchContext: MultiItemSearchContextInput!) {
  createMultiItemSession(context: $context, searchContext: $multiItemSearchContext) {
      __typename
    ... on MultiItemSearchContextCreatedResponse {
      shoppingContext {
        multiItem {
          id
          packageType
        }
      }
    }
  }
}

    `;

    export const createSessionCartQuery = templateJoin`
        mutation CreateSessionCart($context: ContextInput!, $cartOptions: CartOptionsInput!) {
    createSessionCart(
        context: $context
        cartOptions: $cartOptions
    ) {
        id
    }
}

    `;

    export const emptyCartQuery = templateJoin`
        mutation EmptyCart($context: ContextInput!, $id: UUID!){
    cartItems(
        id: $id, context: $context
    ) {
        emptyCart {
            id
            itemCount
        }
    }
}
    `;

    export const federatedCartQuery = templateJoin`
        query FederatedCart($context: ContextInput!, $id: UUID) {
    cart(id: $id, context: $context) {
        itemCount
        items {
            id
            ... on PropertyCartItem {
                offers {
                    offerIndex
                    naturalKeys {
                        id
                        roomTypeId
                        ratePlanId
                        checkIn {
                            isoFormat
                        }
                        checkOut {
                            isoFormat
                        }
                        inventoryType
                        rooms {
                            numberOfAdults
                            childAges
                        }
                    }
                    # offer {
                    #     marketingChannelId
                    #     units {
                    #         name
                    #         photos {
                    #             description
                    #             url
                    #         }
                    #         ratePlans {
                    #             priceDetails {
                    #                 availability {
                    #                     available
                    #                     minRoomsLeft
                    #                 }
                    #                 offerBookButton {
                    #                     inputs {
                    #                         ... on LodgingTextInput {
                    #                             name
                    #                             value
                    #                         }
                    #                     }
                    #                 }
                    #                 price {
                    #                     total {
                    #                         currency {
                    #                             code
                    #                             name
                    #                             symbol
                    #                         }
                    #                         formatted
                    #                         raw
                    #                     }
                    #                     lead {
                    #                         currency {
                    #                             code
                    #                             name
                    #                             symbol
                    #                         }
                    #                         formatted
                    #                         raw
                    #                     }
                    #                 }
                    #                 priceAfterLoyaltyPointsApplied {
                    #                     total {
                    #                         currency {
                    #                             code
                    #                             name
                    #                             symbol
                    #                         }
                    #                         formatted
                    #                         raw
                    #                     }
                    #                     lead {
                    #                         currency {
                    #                             code
                    #                             name
                    #                             symbol
                    #                         }
                    #                         formatted
                    #                         raw
                    #                     }
                    #                 }
                    #                 fees {
                    #                     description
                    #                 }
                    #             }
                    #         }
                    #     }
                    # }
                }
                # propertySummary(context: $context) {
                #     name
                #     location {
                #         address {
                #             city
                #         }
                #     }
                # }
                # propertyGallery(context: $context) {
                #     featured {
                #         url
                #     }
                # }
            }
        }
    }
}

    `;

    export const cartQuery = templateJoin`
        query Cart($context: ContextInput!, $id: UUID) {
    cart(
        id: $id, context: $context
    ) {
      itemCount
      items {
        id
        ... on PropertyCartItem {
          offers {
            offerIndex
            naturalKeys {
              id
              roomTypeId
              ratePlanId
              ratePlanType
              checkIn {
                isoFormat
              }
              checkOut {
                isoFormat
              }
              inventoryType
              rooms {
                 numberOfAdults
                 childAges
              }
            }
            offer {
                marketingChannelId
                units {
                    name
                    photos {
                        description
                        url
                    }
                    ratePlans {
                        priceDetails {
                            availability {
                                available
                                minRoomsLeft
                            }
                            offerBookButton {
                                inputs {
                                    ... on LodgingTextInput {
                                        name
                                        value
                                    }
                                }
                            }
                            price {
                                total {
                                    currency {
                                        code
                                        name
                                        symbol
                                    }
                                    formatted
                                    raw
                                }
                                lead {
                                    currency {
                                        code
                                        name
                                        symbol
                                    }
                                    formatted
                                    raw
                                }
                            }
                            priceAfterLoyaltyPointsApplied {
                                total {
                                    currency {
                                        code
                                        name
                                        symbol
                                    }
                                    formatted
                                    raw
                                }
                                lead {
                                    currency {
                                        code
                                        name
                                        symbol
                                    }
                                    formatted
                                    raw
                                }
                            }
                            fees {
                                description
                            }
                        }
                    }
                }
            }
          }
          summary {
            name
            location {
              address {
                city
              }
            }
          }
          gallery {
            featured {
              url
            }
          }
        }
      }
    }
  }

    `;

    export const initiateMultiItemSessionQuery = templateJoin`
        mutation InitiateMultiItemSession($context: ContextInput! $searchContext: MultiItemSearchContextInput!) {
    multiItemShopping(context: $context) {
        initiate(searchContext: $searchContext) {
            __typename
            ... on MultiItemSearchContextCreatedResponse {
                shoppingContext {
                    multiItem {
                        id
                        packageType
                    }
                }
                redirectUrl
            }
            ... on MultiItemSearchContextErrorResponse {
                message
            }
        }
    }
}

    `;

    export const propertyLocationScoreInfoQuery = templateJoin`
        query PropertyLocationScoreInfo($propertyIds: [String!]!, $context: ContextInput!) {
    propertyReviewAggregates(
        propertyIds: $propertyIds,
        context: $context
    ) {
        propertySummaries {
            propertyId
            locationScore {
                score
                tags {
                    label
                }
            }
        }
    }
}

    `;

    export const lodgingPwaPropertySearchQuery = templateJoin`
        query LodgingPwaPropertySearch(
    $context: ContextInput!
    $destination: DestinationInput!
    $rooms: [RoomInput!]
    $dateRange: PropertyDateRangeInput
    $sort: PropertySort
    $filters: PropertySearchFiltersInput
    $marketing: PropertyMarketingInfoInput
    $legacyCriteria: LegacyPropertySearchCriteriaInput
    $propertyShopOptions: PropertyShopOptionsInput
    $searchPagination: PaginationInput
    $searchIntent: SearchIntentInput
    $shoppingContext: ShoppingContextInput
    $criteria: PropertySearchCriteriaInput
    $shouldFetchSortAndFilter: Boolean = true
) {
    propertySearch(
        context: $context
        destination: $destination
        rooms: $rooms
        dateRange: $dateRange
        sort: $sort
        filters: $filters
        marketing: $marketing
        legacyCriteria: $legacyCriteria
        propertyShopOptions: $propertyShopOptions
        searchPagination: $searchPagination
        searchIntent: $searchIntent
        shoppingContext: $shoppingContext
        criteria: $criteria
    ) {
        searchCriteria {
            propertyShopOptions {
                points
            }
            dateRange {
                checkInDate {
                    ...CommonDateFields
                }
                checkOutDate {
                    ...CommonDateFields
                }
            }
            destination {
                regionId
                regionName
            }
            searchIntent {
                theme
                userIntent
                semdtl
            }
            sort
            filters {
                accessibility
                amenities
                bedroomFilter
                commissionTiers
                agencyBusinessModels
                deals
                paymentType
                poi
                priceBuckets
                propertyName
                propertyStyles
                reviewScore {
                    min
                    max
                }
                starList
                structureTypes
                stayTypes
                travelerType
                mealPlan
                cleaningAndSafetyPractices
            }
        }
        sortAndFilter @include(if: $shouldFetchSortAndFilter) {
            defaults {
                sort
                regionId
            }
            selected {
                priceFilterPills {
                    aggregate {
                        label
                        value
                    }
                    buckets
                }
                star
            }
            options {
                accessibilityLabel
                appliedFilterCount
                sortAndFilter {
                    selected
                    isRange
                    label
                    max
                    min
                    placeholder
                    step
                    subLabel
                    name
                    title
                    hiddenThreshold: seeMoreOptionsToggleThreshold
                    showListOptions {
                        seeMoreLabel
                        seeLessLabel
                        hiddenThreshold
                    }
                    dropdownOptions {
                        isDropDownVisible
                    }
                    options {
                        selectedLabel
                        ariaLabel
                        description
                        icon
                        isSelected
                        label
                        value
                        optionValue
                        range {
                            min
                            max
                        }
                        filterType
                    }
                }
            }
        }
        propertySearchListings {
            __typename
            ... on Property {
                ...PropertyFields
            }
            ... on MessageResult {
                ...MessageFields
            }
            ... on LodgingHeading {
                value
                size
                tag
            }
            ... on StaticLodgingMultiItemCrossSell {
                crossSellProductType
                fallbackListing {
                    __typename
                    ... on MessageResult {
                        ...MessageFields
                    }
                }
            }
        }
        summary {
            resultsSummary {
                __typename
                value
                ... on LodgingLinkMessage {
                    ...SearchLinkMessage
                }
                ... on LodgingDialogTriggerMessage {
                    ...SearchDialogMessage
                }
            }
            pricedHotelSize
            region {
                name
                id
            }
            resultSectionHeadings {
                heading
                index
            }
            loyaltyEducation {
                action {
                    href
                    rfrr
                    text
                }
                content {
                    __typename
                    ...PointsEducationFragment
                    ...ProgramEducationFragment
                }
                title
            }
            loyaltyInfo {
                pointsAppliedMessage
                saveWithPointsMessage
                saveWithPointsActionMessage
            }
            matchedPropertiesSize
            resultsHeading
        }
        navigationTabs {
            tabs {
                localizedName
                sectionName
                state
                tabLink {
                    link {
                        url
                        uri {
                            value
                        }
                        target
                    }
                    value
                }
            }
        }
        map {
            bounds {
                northeast {
                    latitude
                    longitude
                }
                southwest {
                    latitude
                    longitude
                }
            }
            center {
                latitude
                longitude
            }
            markers {
                mapMarker {
                    label
                    icon
                    type
                    latLong {
                        latitude
                        longitude
                    }
                    clientSideAnalytics {
                        referrerId
                        linkName
                    }
                }
                __typename
                ... on Property {
                    ...CommonPropertyCardFields
                }
                ... on PointOfInterest {
                    name: title
                }
            }
            staticMapSrc
            title
            subtitle
            zoom
            messagingModel {
                title {
                    text
                    theme
                    icon {
                        description
                        id
                    }
                }
                subtitle {
                    text
                    theme
                    icon {
                        description
                        id
                    }
                }
                type
            }
        }
        exitIntent {
            logoUrl
            backgroundImageUrl
            clickHereLinkUrl
            message {
                headingOne
                headingTwo
                headingThree
                couponCode
                percentOff
                termsAndConditionsOne
                termsAndConditionsTwo
                clickHere
            }
        }
        legalDisclaimer {
            content {
                markupType
                text
            }
        }
        shoppingContext {
            multiItem {
                id
                packageType
            }
        }
        multiItemSearchContext {
            ...MultiItemPropertySearchContextFields
            cars {
                primary {
                    pickUpDateTime {
                        ...CommonDateTimeFields
                    }
                    dropOffDateTime {
                        ...CommonDateTimeFields
                    }
                    pickUpLocation {
                        airportCode
                    }
                    dropOffLocation {
                        airportCode
                    }
                }
            }
            flights {
                primary {
                    travelers {
                        type
                        age
                    }
                    tripType
                    journeyCriterias {
                        destination
                        origin
                        departureDate {
                            day
                            month
                            year
                        }
                    }
                    searchPreferences {
                        airline
                        advancedFilters
                        cabinClass
                    }
                }
            }
        }
        errorResponse {
            header
            body
            icon {
                description
                id
            }
            button {
                primary
                action {
                    ... on UILinkAction {
                        analytics {
                            referrerId
                            linkName
                        }
                        resource {
                            ... on HttpURI {
                                relativePath
                                value
                            }
                        }
                    }
                }
                disabled
            }
            errorRecoveryButtons {
                primary
                action {
                    ... on UILinkAction {
                        analytics {
                            referrerId
                            linkName
                        }
                        resource {
                            ... on HttpURI {
                                relativePath
                                value
                            }
                        }
                    }
                }
                disabled
            }
        }
        dialogErrorResponse {
            body
            button {
                primary
                action {
                    ... on UILinkAction {
                        analytics {
                            referrerId
                            linkName
                        }
                        resource {
                            ... on HttpURI {
                                relativePath
                                value
                            }
                        }
                    }
                }
                disabled
            }
        }
    }
}

fragment MultiItemPropertySearchContextFields on MultiItemSearchContext {
    properties {
        primary {
            rooms {
                adults
            }
            destination {
                regionId
                regionName
            }
            dateRange {
                checkInDate {
                    ...CommonDateFields
                }
                checkOutDate {
                    ...CommonDateFields
                }
            }
        }
    }
}

fragment MessageFields on MessageResult {
    title {
        ...MessageTitleFields
    }
    subtitle {
        ...MessageTitleFields
    }
    action {
        primary {
            ...MessagingActionFields
        }
        secondary {
            ...MessagingActionFields
        }
    }
    index
    type
}

fragment MessageTitleFields on MessagingResultTitle {
    text
    icon {
        description
        id
    }
    mark {
        description
        id
    }
    illustration {
        assetUri {
            value
        }
        description
    }
    theme
}

fragment MessagingActionFields on MessagingAction {
    actionDetails {
        details
        name
        title
        accessibilityLabel
    }
    linkUrl
    referrerId
    text
}

fragment PropertyFields on Property {
    ...CommonPropertyCardFields
    amenities {
        icon
        name
    }
    star
    starRatingIcon
    availability {
        available
        text
        theme
    }
    offerSummary {
        messages {
            message
            theme
            type
            mark {
                id
                url {
                    value
                }
            }
        }
    }
    legalDisclaimer {
        title
        disclaimerContents
    }
    imageGallery {
        accessibilityLabel
        images {
            image {
                url
                description
            }
            subjectId
            fallbackImage {
                url
                description
            }
            imageId
        }
    }
    mapMarker {
        icon
        label
        type
        latLong {
            latitude
            longitude
        }
        clientSideAnalytics {
            referrerId
            linkName
        }
    }
    neighborhood {
        name
    }
    offerBadge {
        primary {
            text
            theme_temp
            icon_temp {
                id
                description
            }
            mark {
                id
                description
            }
        }
        secondary {
            text
            theme_temp
            icon_temp {
                id
                description
                title
            }
        }
    }
    pinnedDetails {
        heading
    }
    recentlyViewed {
        id
        description
    }
    featuredMessages {
        ...featuredMessage
    }
    supportingMessages
    shortList {
        favorited
        saveUrl
        removeUrl
        metaData {
            chkIn
            chkOut
            hotelId
            roomConfiguration
        }
    }
    highlightedPropertyDetails
    propertySource {
        accessibilityLabel
        label
        graphic {
            __typename
            ... on Mark {
                description
                id
                size
                token
                url {
                    value
                }
            }
        }
        text {
            value
        }
    }
    dataAttributes {
        key
        value
    }
    listingFooter {
        actionDetails {
            name
        }
        icon {
            description
            id
        }
        linkUrl
        referrerId
        text
    }
}

fragment SearchLinkMessage on LodgingLinkMessage {
    label
    link {
        ...SearchLink
    }
    icon {
        id
    }
}

fragment SearchDialogMessage on LodgingDialogTriggerMessage {
    dialogTrigger {
        dialogName
        referrerId
        actionDetails {
            linkUrl
            referrerId
            message
            text
        }
    }
    icon {
        id
    }
}

fragment SearchLink on LodgingLink {
    url
    referrerId
}

fragment DisplayPriceFragment on DisplayPrice {
    __typename
    role
    price {
        formatted
        accessibilityLabel
    }
    disclaimer {
        content
        primaryUIButton {
            accessibility
            primary
        }
    }
}

fragment EnrichedMessageFragment on LodgingEnrichedMessage {
    __typename
    value
    state
}

fragment CommonPropertyCardFields on Property {
    id
    name
    propertyImage {
        image {
            description
            url
        }
        fallbackImage {
            description
            url
        }
    }
    offerBadge {
        primary {
            text
            theme_temp
            icon_temp {
                id
                description
            }
            mark {
                id
                description
            }
        }
        secondary {
            text
            theme_temp
            icon_temp {
                id
                description
            }
        }
    }
    price {
        alignment
        displayMessages {
            lineItems {
                ...DisplayPriceFragment
                ...EnrichedMessageFragment
            }
        }
        lead {
            formatted
        }
        strikeOutType
        strikeOut {
            formatted
        }
        disclaimer {
            value
        }
        roomNightMessage
        priceMessages {
            value
        }
        marketingFeeDetails {
            tierName
            tierIcon
            marketingFeeMessage {
                value
            }
        }
        options {
            leadingCaption
            displayPrice {
                formatted
            }
            strikeOut {
                formatted
            }
            loyaltyPrice {
                amount {
                    formatted
                }
                totalStrikeOutPoints {
                    formatted
                }
                unit
            }
            disclaimer {
                value
            }
        }
    }
    reviews {
        score
        localizedScore
        total
        localizedTotal
        superlative
        localizedSubtitle
        localizedSubtitleA11y {
            accessibilityLabel
            value
        }
        mark {
            id
            description
        }
    }
    destinationInfo {
        distanceFromMessaging
    }
    vipMessaging
    propertyDetailsLink {
        uri {
            value
            relativePath
        }
        clientSideAnalytics {
            referrerId
            linkName
        }
    }
    sponsoredListing {
        id
        clickRedirectTrackingUrl
        clickTrackingUrl
        details
        detailsHeadline
        hotelImage
        impressionTrackingUrl
        trackingData
        brand
        clickRedirectLinkoffTrackingUrl
        logo
        lotagline
        rating
        slots
        vanityUrl
        rank
        position
    }
}

fragment CommonDateFields on Date {
    year
    month
    day
}

fragment CommonDateTimeFields on DateTime {
    year
    month
    day
    hour
    minute
    second
}

fragment PointsEducationFragment on LoyaltyPointsEducation {
    description
    programFeatures {
        description
        perks {
            ...PerksFragment
        }
        title
    }
    heroImage {
        url
        description
    }
}

fragment ProgramEducationFragment on LoyaltyProgramEducation {
    joinProgramText
    perks {
        ...PerksFragment
    }
}

fragment PerksFragment on LoyaltyEducationPerks {
    descriptions
    icon
}

fragment featuredMessage on LodgingEnrichedMessage {
    icon {
        id
        description
        size
    }
    value
}

    `;

    export const lodgingPwaPropertySearchSortAndFilterQuery = templateJoin`
        query LodgingPwaPropertySearchSortAndFilter(
    $context: ContextInput!
    $destination: DestinationInput!
    $rooms: [RoomInput!]
    $dateRange: PropertyDateRangeInput
    $sort: PropertySort
    $filters: PropertySearchFiltersInput
    $marketing: PropertyMarketingInfoInput
    $legacyCriteria: LegacyPropertySearchCriteriaInput
    $propertyShopOptions: PropertyShopOptionsInput
    $searchPagination: PaginationInput
    $searchIntent: SearchIntentInput
    $shoppingContext: ShoppingContextInput
    $criteria: PropertySearchCriteriaInput
) {
    propertySearch(
        context: $context
        destination: $destination
        rooms: $rooms
        dateRange: $dateRange
        sort: $sort
        filters: $filters
        marketing: $marketing
        legacyCriteria: $legacyCriteria
        propertyShopOptions: $propertyShopOptions
        searchPagination: $searchPagination
        searchIntent: $searchIntent
        shoppingContext: $shoppingContext
        criteria: $criteria
    ) {
        sortAndFilter {
            defaults {
                sort
                regionId
            }
            selected {
                priceFilterPills {
                    aggregate {
                        label
                        value
                    }
                    buckets
                }
                star
            }
            options {
                appliedFilterCount
                sortAndFilter {
                    selected
                    isRange
                    label
                    max
                    min
                    name
                    title
                    placeholder
                    step
                    subLabel
                    hiddenThreshold: seeMoreOptionsToggleThreshold
                    showListOptions {
                        seeMoreLabel
                        seeLessLabel
                        hiddenThreshold
                    }
                    dropdownOptions {
                        isDropDownVisible
                    }
                    options {
                        selectedLabel
                        ariaLabel
                        description
                        icon
                        isSelected
                        label
                        value
                        optionValue
                        range {
                            min
                            max
                        }
                        filterType
                    }
                }
            }
        }
    }
}

    `;

    export const prepareCheckoutByCartIdQuery = templateJoin`
        mutation PrepareCheckoutByCartId($context: ContextInput!, $id: UUID!, $totalPrice: MoneyInput!, $marketingChannelId: Int, $checkoutOptions: [CheckoutOptionInput!]) {
    prepareCheckoutByCartId(context: $context, cartId: $id, totalPrice: $totalPrice, marketingChannelId: $marketingChannelId, checkoutOptions: $checkoutOptions) {
        tripId
        checkoutUrl
        failureReason {
            ... on MaxRoomsFailure {
                groupLinkMessage
                message
            }
        }
    }
}

    `;

    export const prepareCheckoutQuery = templateJoin`
        mutation PrepareCheckout($context: ContextInput!, $properties: [PropertyNaturalKeyInput!], $cookies: String!) {
    prepareCheckout(context: $context, properties: $properties, cookies: $cookies) {
        tripId
        checkoutUrl
    }
}

    `;

    export const propertyAvailabilityCheckQuery = templateJoin`
        query PropertyAvailabilityCheck(
    $context: ContextInput!
    $propertyId: String!
    $searchCriteria: PropertySearchCriteriaInput!
) {
    propertyOffers(
        context: $context
        propertyId: $propertyId,
        searchCriteria: $searchCriteria
    ) {
        errorMessage {
            title {
                text
            }
        },
        listings {
            ...on PropertyUnit {
                id
            }
        }
    }
}

    `;

    export const propertyInfoPageLayoutQuery = templateJoin`
        query PropertyInfoPageLayout(
    $context: ContextInput!
    $propertyId: String!
    $shoppingContext: ShoppingContextInput
) {
  propertyInfo(context: $context, propertyId: $propertyId, shoppingContext: $shoppingContext) {
    experimental {
      pageLayoutExperimentalFeature {
        templateName
      }
    }
  }
}
    `;

    export const propertyRoomScoreInfoQuery = templateJoin`
        query PropertyRoomScoreInfo($propertyIds: [String!]!, $context: ContextInput!) {
    propertyReviewAggregates(propertyIds: $propertyIds, context: $context) {
        propertySummaries {
            propertyId
            roomsScore {
                roomRatingListTitle
                id
                score
                scoreLabel
                tags {
                    label
                }
            }
        }
    }
}

    `;

    export const propertyOffersQuery = templateJoin`
        query PropertyOffers(
    $context: ContextInput!
    $propertyId: String!
    $searchCriteria: PropertySearchCriteriaInput
    $shoppingContext: ShoppingContextInput
    $travelAdTrackingInfo: PropertyTravelAdTrackingInfoInput
    $searchOffer: SearchOfferInput
    $referrer: String
) {
    propertyOffers(
        context: $context
        propertyId: $propertyId
        searchCriteria: $searchCriteria
        shoppingContext: $shoppingContext
        travelAdTrackingInfo: $travelAdTrackingInfo
        searchOffer: $searchOffer
        referrer: $referrer
    ) {
        propertyHighlightSection {
            label
            header {
                badge {
                    icon_temp {
                        id
                    }
                    theme_temp
                    theme
                    text
                }
                mark {
                    id
                    description
                }
            }
            subSections {
                description
                contents {
                    icon {
                        id
                        withBackground
                        description
                    }
                    value
                }
            }
            footerLink {
                icon {
                    id
                }
                link {
                    referrerId
                    uri {
                        relativePath
                        value
                    }
                    target
                }
                value
            }
        }
        propertySearchLink {
            icon {
                id
            }
            link {
                clientSideAnalytics {
                    referrerId
                    linkName
                }
                uri {
                    relativePath
                    value
                }
                referrerId
            }
            value
        }
        partnerPropertySearchLink {
            icon {
                id
            }
            link {
                uri {
                    relativePath
                    value
                }
                referrerId
            }
            value
        }
        filterPills {
            pillLabel
            type
            value
            state
            query
        }
        loading {
            accessibilityLabel
        }
        listingsHeader {
            text
        }
        searchCriteria {
            primary {
                dateRange {
                    checkInDate {
                        ...DateFragment
                    }
                    checkOutDate {
                        ...DateFragment
                    }
                }
                destination {
                    regionId
                }
                rooms {
                    adults
                    children {
                        age
                    }
                }
            }
            secondary {
                booleans {
                    id
                    value
                }
                counts {
                    id
                    value
                }
                dates {
                    id
                    value {
                        isoFormat
                    }
                }
                ranges {
                    id
                    min
                    max
                }
                selections {
                    id
                    value
                }
            }
        }
        tripSummary {
            ...TripSummaryFragment
        }
        listings {
            ...UnitFragment
        }
        categorizedListings {
            ...CategorizedUnitFragment
            ...MessageFragment
        }
        errorMessage {
            title {
                text
            }
            action {
                primary {
                    text
                    linkUrl
                }
            }
        }
        paymentPolicy {
            ...PaymentPolicyFragment
        }
        serpMetadata {
            priceRange {
                value
            }
            priceRating {
                value
            }
        }
        soldOut
        stickyBar {
            displayPrice
            qualifier
            subText
            stickyButton {
                text
                targetRef
            }
            price {
                leadingCaption
                displayPrice {
                    formatted
                }
                disclaimer {
                    value
                }
            }
        }
        toastMessage {
            value
        }
        loyaltyDiscount {
            saveWithPointsMessage
            saveWithPointsActionMessage
        }
        legalDisclaimer {
            content {
                markupType
                text
            }
        }
        propertyLevelOffersMessage {
            ...MessageFragment
        }
        offerLevelMessages {
            ...MessageFragment
        }
        alternateDates {
            ...AlternateDatesFragment
        }
        alternateAvailabilityMsg {
            ...AlternateAvailabilityMsgFragment
        }
        shoppingContext {
            multiItem {
                id
                packageType
            }
        }
        singleUnitOffer {
            ...SingleOfferFragment
        }
        singleUnitOfferDialog {
            content {
                ...SingleOfferFragment
            }
            toolbar {
                ...LodgingDialogToolbarFragment
            }
            trigger {
                ...LodgingDialogTriggerMessageFragment
            }
        }
        spaceDetails {
            header {
                text
                subText
            }
            floorPlan {
                images {
                    alt
                    image {
                        description
                        url
                    }
                    subjectId
                }
                toolbar {
                    ...LodgingDialogToolbarFragment
                }
                trigger {
                    ...LodgingDialogTriggerMessageFragment
                }
            }
            spaces {
                name
                description
                icons {
                    ...IconFragment
                }
            }
            summary
        }
    }
}

fragment AlternateDatesFragment on AlternateDatesCard {
    header {
        text
        subText
    }
    options {
        ...AlternateDateOptionFragment
    }
}

fragment AlternateAvailabilityMsgFragment on LodgingComplexLinkMessage {
    text {
        value
    }
    actionLink {
        link {
            uri {
                relativePath
                value
            }
        }
        value
    }
}

fragment PropertyUnitDetailsDialog on PropertyUnitDetailsDialog {
    content {
        ratePlanTitle {
            text
        }
        details {
            header {
                text
                subText
            }
            contents {
                heading
                items {
                    text
                }
            }
        }
    }
    trigger {
        value
        clientSideAnalytics {
            referrerId
            linkName
        }
        dialogTrigger {
            clientSideAnalytics {
                referrerId
            }
        }
    }
    toolbar {
        title
        icon {
            description
        }
        clientSideAnalytics {
            referrerId
            linkName
        }
    }
}

fragment MessageFragment on MessageResult {
    __typename
    type
    title {
        ...TitleFragment
    }
    subtitle {
        ...TitleFragment
    }
    action {
        primary {
            ...ActionFragment
        }
        secondary {
            ...ActionFragment
        }
    }
    featuredImage {
        url
        description
    }
}

fragment TitleFragment on MessagingResultTitle {
    text
    theme
    icon {
        ...IconFragment
    }
    mark {
        id
        description
    }
    illustration {
        assetUri {
            value
        }
        description
    }
}

fragment ActionFragment on MessagingAction {
    linkUrl
    text
    referrerId
    actionDetails {
        name
        details
        title
        accessibilityLabel
        action
    }
    icon {
        id
    }
}

fragment LodgingNotificationsCardFragment on LodgingNotificationsCard {
    header {
        text
    }
    messages {
        ...LodgingEnrichedMessageFragment
    }
}

fragment UnitCategorizationSelectionFragment on LodgingOfferOption {
    description
    subText
    enabled
    price
    optionId
    clientSideAnalytics {
        ...ClientSideAnalyticsFragment
    }
    dialog {
        ...LodgingPlainDialogFragment
    }
}

fragment UnitCategorizationHeaderFragment on LodgingOfferSelectionHeader {
    dialog {
        content {
            content
            title {
                text
                subText
            }
        }
        primaryUIButton {
            ...UIPrimaryButtonFragment
        }
        toolbar {
            ...LodgingDialogToolbarFragment
        }
        trigger {
            ...LodgingDialogTriggerMessageFragment
        }
    }
    title {
        text
        subText
    }
}

fragment CategorizedUnitFragment on LodgingCategorizedUnit {
    __typename
    label
    header {
        text
    }
    highlightedMessages {
        ...CancellationPolicyFragment
    }
    features {
        text
        moreInfo
        graphic {
            __typename
            ... on Icon {
                ...IconFragment
            }
            ... on Mark {
                description
                id
            }
        }
        graphic {
            __typename
            ...IconFragment
            ...MarkFragment
        }
        moreInfoDialog {
            ...LodgingPlainFullscreenDialogFragment
        }
    }
    primaryHeader {
        ...UnitCategorizationHeaderFragment
    }
    secondaryHeader {
        ...UnitCategorizationHeaderFragment
    }
    tertiaryHeader {
        ...UnitCategorizationHeaderFragment
    }
    primarySelections {
        primarySelection {
            ...UnitCategorizationSelectionFragment
        }
        secondarySelections {
            recommendedSelection
            secondarySelection {
                ...UnitCategorizationSelectionFragment
            }
            tertiarySelections {
                ...UnitCategorizationSelectionFragment
            }
        }
        propertyUnit {
            __typename
            id
            unitGallery {
                accessibilityLabel
                label
                images {
                    image {
                        description
                        url
                    }
                }
            }
            availabilityCallToAction {
                __typename
                ... on LodgingPlainMessage {
                    value
                }
                ... on LodgingButton {
                    text
                }
            }
            detailsDialog {
                ...PropertyUnitDetailsDialog
            }
            roomAmenities {
                header {
                    text
                }
                bodySubSections {
                    contents {
                        header {
                            icon {
                                id
                            }
                            text
                        }
                        items {
                            ... on PropertyContentItemMarkup {
                                content {
                                    text
                                }
                            }
                        }
                    }
                }
            }
            ratePlans {
                ...RatePlanFragment
            }
        }
    }
}

fragment UnitFragment on PropertyUnit {
    __typename
    bedOptions {
        name
        icon
    }
    id
    name
    header {
        icon {
            ...IconFragment
        }
        text
        subText
    }
    detailsDialog {
        ...PropertyUnitDetailsDialog
    }
    ratePlans {
        ...RatePlanFragment
    }
    unavailableRatePlans {
        ...RatePlanFragment
    }
    ratePlansExpando {
        expandButton {
            text
        }
    }
    features {
        text
        moreInfo
        graphic {
            __typename
            ... on Icon {
                ...IconFragment
            }
            ... on Mark {
                description
                id
            }
        }
        graphic {
            __typename
            ...IconFragment
            ...MarkFragment
        }
        moreInfoDialog {
            ...LodgingPlainFullscreenDialogFragment
        }
    }
    spaceDetails {
        header {
            text
            subText
        }
        floorPlan {
            images {
                alt
                image {
                    description
                    url
                }
                subjectId
            }
            toolbar {
                ...LodgingDialogToolbarFragment
            }
            trigger {
                ...LodgingDialogTriggerMessageFragment
            }
        }
        spaces {
            name
            description
            icons {
                ...IconFragment
            }
        }
        summary
    }
    roomAmenities {
        header {
            text
        }
        bodySubSections {
            contents {
                header {
                    text
                    icon {
                        id
                    }
                }
                items {
                    ... on PropertyContentItemMarkup {
                        content {
                            text
                        }
                    }
                }
            }
        }
    }
    unitGallery {
        images {
            alt
            image {
                description
                url
            }
            thumbnail {
                description
                url
            }
            fallbackImage {
                description
                url
            }
            subjectId
        }
        accessibilityLabel
    }
    availabilityCallToAction {
        __typename
        ... on LodgingPlainMessage {
            value
        }
        ... on LodgingButton {
            text
        }
    }
}

fragment CancellationPolicyFragment on RatePlanMessage {
    __typename
    ...LodgingPlainDialogFragment
    ...LodgingEnrichedMessageFragment
}

fragment DateFragment on Date {
    month
    day
    year
    shortDateFormat
}

fragment RatePlanFragment on RatePlan {
    id
    name
    description
    loyaltyMessage {
        value
        state
        mark {
            id
        }
        egdsMark {
            url {
                value
            }
        }
        label
    }
    headerMessage {
        value
        subText
        theme
        label
    }
    priceDetails {
        ...PriceDetailsFragment
    }
    amenities {
        id
        additionalInformation
        category
        description
        icon {
            id
            description
            size
        }
    }
    marketingSection {
        ...MarketingSectionFragment
    }
    offerNotifications {
        ...LodgingNotificationsCardFragment
    }
    highlightedMessages {
        ...LodgingEnrichedMessageFragment
        ...LodgingPlainMessageFragment
        ...LodgingPlainDialogFragment
    }
    marketingChannelMessage {
        value
        mark {
            id
        }
    }
    badge {
        text
        theme_temp
        icon_temp {
            id
            description
            size
        }
    }
    etpDialogTopMessage {
        ...MessageFragment
    }
    paymentPolicy {
        ...PaymentPolicyFragment
    }
    reserveCallToAction {
        __typename
        ... on EtpDialog {
            trigger {
                value
            }
            toolbar {
                icon {
                    description
                }
                title
            }
        }
        ... on LodgingForm {
            action
            inputs {
                ... on LodgingTextInput {
                    name
                    type
                    value
                }
            }
            method
            submit {
                text
            }
        }
    }
    shareUrl {
        accessibilityLabel
        link {
            uri {
                relativePath
            }
        }
        value
    }
}

fragment PriceDetailsFragment on Offer {
    optionTitle {
        text
    }
    availability {
        available
        text
        theme
        scarcityMessage
    }
    price {
        ...PriceDisplayFragment
        options {
            ...OptionFragment
        }
        priceMessaging {
            value
            theme
        }
        lead {
            formatted
        }
        disclaimer {
            value
        }
        roomNightMessage
        strikeOut {
            formatted
        }
        strikeOutType
        marketingFeeDetails {
            tierName
            tierIcon
            marketingFeeMessage {
                value
            }
        }
        multiItemPriceToken
    }
    cancellationPolicy {
        type
        text
        cancellationWindow {
            day
            month
            year
            hour
            minute
            second
            timeZoneOffsetSeconds
            fullDateFormat
        }
    }
    ...PricePresentationDialogFragment
    priceBreakDownSummary {
        priceSummaryHeading {
            ...LodgingEnrichedMessageFragment
        }
        sections {
            sectionHeading {
                ...LodgingEnrichedMessageFragment
            }
            items {
                name {
                    primaryMessage {
                        ...LodgingEnrichedMessageFragment
                    }
                    secondaryMessages {
                        ...LodgingEnrichedMessageFragment
                    }
                }
                value {
                    primaryMessage {
                        ...LodgingEnrichedMessageFragment
                    }
                    secondaryMessages {
                        ...LodgingEnrichedMessageFragment
                    }
                }
            }
            sectionFooter {
                footerHeading {
                    ...LodgingEnrichedMessageFragment
                }
                footerMessages {
                    ...LodgingEnrichedMessageFragment
                }
            }
        }
        disclaimers {
            ...LodgingEnrichedMessageFragment
        }
    }
    pointsApplied
    dataAttributes {
        key
        value
    }
    feeMessages {
        value
    }
    loyaltyMessage {
        state
        value
    }
    offerBookButton {
        action
        inputs {
            ...LodgingTextInput
        }
        method
        submit {
            ...ButtonFragment
        }
    }
    paymentModel
    noCreditCard
    installmentPayable
    totalPriceMessage
    deposit {
        ...MoneyFragment
    }
    hotelCollect
    etpModalPolicies
    propertyNaturalKeys {
        ...PropertyNaturalKeyFragment
    }
}

fragment PropertyNaturalKeyFragment on PropertyNaturalKey {
    id
    checkIn {
        ...DateFragment
    }
    checkOut {
        ...DateFragment
    }
    inventoryType
    noCreditCard
    ratePlanId
    ratePlanType
    roomTypeId
    rooms {
        childAges
        numberOfAdults
    }
    shoppingPath
}

fragment ButtonFragment on LodgingButton {
    text
    analytics {
        linkName
        referrerId
    }
}

fragment IconFragment on Icon {
    description
    id
    size
}

fragment MarkFragment on Mark {
    id
    description
}

fragment MarketingSectionFragment on MarketingSection {
    title {
        text
    }
    feeDetails {
        formattedFee
        marketingFeeMessage {
            value
        }
        mark {
            id
        }
        tierName
        tierMessage {
            value
            icon {
                id
                description
                size
            }
            mark {
                id
            }
        }
    }
    feeDialog {
        title
        content
        tertiaryUIButton {
            primary
        }
        trigger {
            value
            mark {
                id
            }
            icon {
                id
                size
            }
            clientSideAnalytics {
                linkName
                referrerId
            }
        }
    }
    paymentDetails {
        icon {
            id
        }
        value
    }
}

fragment LodgingTextInput on LodgingTextInput {
    name
    type
    value
}

fragment PaymentPolicyFragment on PropertyPaymentPolicyInfo {
    __typename
    paymentType
    heading
    descriptions {
        heading
        items {
            text
        }
    }
}

fragment OptionFragment on PropertyPriceOption {
    disclaimer {
        ...LodgingPlainMessageFragment
    }
    priceDisclaimer {
        ...LodgingPlainDialogFragment
    }
    displayPrice {
        ...MoneyFragment
    }
    leadingCaption
    loyaltyPrice {
        amount {
            formatted
            raw
        }
        totalStrikeOutPoints {
            formatted
        }
        unit
    }
    strikeOut {
        ...MoneyFragment
    }
    accessibilityLabel
}

fragment LodgingEnrichedMessageFragment on LodgingEnrichedMessage {
    __typename
    icon {
        id
        description
        size
    }
    label
    mark {
        id
        description
    }
    theme
    subText
    value
}

fragment LodgingPlainMessageFragment on LodgingPlainMessage {
    __typename
    value
}

fragment LodgingPlainDialogFragment on LodgingPlainDialog {
    __typename
    content
    primaryButton {
        ...ButtonFragment
    }
    secondaryButton {
        ...ButtonFragment
    }
    tertiaryButton {
        ...ButtonFragment
    }
    primaryUIButton {
        ...UIPrimaryButtonFragment
    }
    secondaryUIButton {
        primary
    }
    title
    toolbar {
        ...LodgingDialogToolbarFragment
    }
    trigger {
        ...LodgingDialogTriggerMessageFragment
    }
}

fragment UIPrimaryButtonFragment on UIPrimaryButton {
    __typename
    action {
        __typename
        analytics {
            __typename
            linkName
            referrerId
        }
        ... on UILinkAction {
            __typename
            resource {
                __typename
                value
            }
        }
    }
    primary
}

fragment LodgingPlainFullscreenDialogFragment on LodgingPlainDialog {
    __typename
    content
    trigger {
        clientSideAnalytics {
            linkName
            referrerId
        }
        icon {
            description
            id
        }
        theme
        value
    }
    toolbar {
        title
        icon {
            description
        }
        clientSideAnalytics {
            linkName
            referrerId
        }
    }
}

fragment LodgingDialogToolbarFragment on LodgingDialogToolbar {
    icon {
        ...IconFragment
    }
    title
    clientSideAnalytics {
        ...ClientSideAnalyticsFragment
    }
}

fragment LodgingDialogTriggerMessageFragment on LodgingDialogTriggerMessage {
    clientSideAnalytics {
        ...ClientSideAnalyticsFragment
    }
    icon {
        ...IconFragment
    }
    theme
    value
    secondaryValue
}

fragment ClientSideAnalyticsFragment on ClientSideAnalytics {
    linkName
    referrerId
}

fragment MoneyFragment on Money {
    amount
    currencyInfo {
        ...CurrencyFragment
    }
    formatted
}

fragment CurrencyFragment on Currency {
    code
    name
    symbol
}

fragment AlternateDateOptionFragment on AlternateDateOption {
    dates {
        link {
            uri {
                relativePath
            }
            referrerId
        }
        value
    }
    price {
        displayPrice {
            formatted
        }
    }
}

fragment TripSummaryFragment on TripSummaryContent {
    header {
        text
    }
    summary {
        value
    }
    price {
        ...PriceDisplayFragment
        options {
            displayPrice {
                formatted
            }
            strikeOut {
                formatted
            }
            accessibilityLabel
            priceDisclaimer {
                content
                tertiaryUIButton {
                    primary
                    action {
                        analytics {
                            referrerId
                            linkName
                        }
                    }
                }
                trigger {
                    clientSideAnalytics {
                        linkName
                        referrerId
                    }
                    value
                }
            }
        }
        priceMessaging {
            value
        }
    }
}

fragment SingleOfferFragment on SingleUnitOfferDetails {
    availabilityCallToAction {
        __typename
        ... on LodgingPlainMessage {
            value
        }
        ... on LodgingButton {
            text
        }
    }
    accessibilityLabel
    displayPrice {
        leadPrice {
            ...LodgingEnrichedMessageFragment
        }
        priceLabel {
            ...LodgingEnrichedMessageFragment
        }
        priceMessages {
            ...LodgingEnrichedMessageFragment
        }
    }
    id
    ratePlans {
        ...RatePlanFragment
    }
    totalPrice {
        amount {
            ...LodgingEnrichedMessageFragment
        }
        label {
            ...LodgingEnrichedMessageFragment
        }
    }
}

fragment PriceDisplayFragment on PropertyPrice {
    alignment
    displayMessages {
        lineItems {
            ...PriceMessageFragment
            ... on LodgingEnrichedMessage {
                __typename
                value
                state
            }
        }
    }
}
fragment PriceMessageFragment on DisplayPrice {
    __typename
    role
    price {
        formatted
        accessibilityLabel
    }
    disclaimer {
        content
        primaryUIButton {
            accessibility
            primary
        }
    }
}

fragment PricePresentationDialogFragment on Offer {
    pricePresentationDialog {
        toolbar {
            title
            icon {
                description
            }
            clientSideAnalytics {
                linkName
                referrerId
            }
        }
        trigger {
            clientSideAnalytics {
                linkName
                referrerId
            }
            value
        }
    }
    pricePresentation {
        title {
            primary
        }
        sections {
            ...PricePresentationSectionFragment
        }
        footer {
            header
            messages {
                ...PriceLineTextFragment
                ...PriceLineHeadingFragment
            }
        }
    }
}

fragment PricePresentationSectionFragment on PricePresentationSection {
    header {
        name {
            ...PricePresentationLineItemEntryFragment
        }
        enrichedValue {
            ...PricePresentationLineItemEntryFragment
        }
    }
    subSections {
        ...PricePresentationSubSectionFragment
    }
}

fragment PriceLineTextFragment on PriceLineText {
    __typename
    theme
    primary
    weight
    additionalInfo {
        ...AdditionalInformationPopoverFragment
    }
    icon {
        id
        description
        size
    }
}

fragment PriceLineHeadingFragment on PriceLineHeading {
    __typename
    primary
    tag
    size
    additionalInfo {
        ...AdditionalInformationPopoverFragment
    }
    icon {
        id
        description
        size
    }
}

fragment PricePresentationLineItemEntryFragment on PricePresentationLineItemEntry {
    primaryMessage {
        ...PriceLineTextFragment
        ...PriceLineHeadingFragment
    }
    secondaryMessages {
        ...PriceLineTextFragment
        ...PriceLineHeadingFragment
    }
}

fragment PricePresentationSubSectionFragment on PricePresentationSubSection {
    header {
        name {
            primaryMessage {
                ... on PriceLineText {
                    primary
                }
                ... on PriceLineHeading {
                    primary
                }
            }
        }
        enrichedValue {
            ...PricePresentationLineItemEntryFragment
        }
    }
    items {
        ...PricePresentationLineItemFragment
    }
}

fragment PricePresentationLineItemFragment on PricePresentationLineItem {
    enrichedValue {
        ...PricePresentationLineItemEntryFragment
    }
    name {
        ...PricePresentationLineItemEntryFragment
    }
}

fragment AdditionalInformationPopoverFragment on AdditionalInformationPopover {
    icon {
        id
        description
        size
    }
    analytics {
        linkName
        referrerId
    }
    enrichedSecondaries {
        ...AdditionalInformationPopoverSectionFragment
    }
}

fragment AdditionalInformationPopoverSectionFragment on AdditionalInformationPopoverSection {
    __typename
    ... on AdditionalInformationPopoverTextSection {
        ...AdditionalInformationPopoverTextSectionFragment
    }
    ... on AdditionalInformationPopoverListSection {
        ...AdditionalInformationPopoverListSectionFragment
    }
}

fragment AdditionalInformationPopoverTextSectionFragment on AdditionalInformationPopoverTextSection {
    __typename
    text {
        text
    }
}

fragment AdditionalInformationPopoverListSectionFragment on AdditionalInformationPopoverListSection {
    __typename
    content {
        __typename
        items {
            text
        }
    }
}

    `;

    export const propertyRateCalendarQuery = templateJoin`
        query PropertyRateCalendar(
    $context: ContextInput!
    $destination: DestinationInput!
    $criteria: PropertySearchCriteriaInput
    $shoppingContext: ShoppingContextInput
) {
    propertySearch(
        context: $context
        destination: $destination
        criteria: $criteria
        shoppingContext: $shoppingContext
    ) {
        rateCalendar {
            disclaimer {
                value
            }
            legend {
                label
                ... on PropertyCalendarPriceTrendLegend {
                    trend
                    symbol
                }
            }
            propertyCalendarRates {
                accessibilityLabel,
                date {
                    isoFormat
                }
                displayPrice
            }
        }
    }
}

    `;

    export const propertySearchTravelAdsQuery = templateJoin`
        query PropertySearchTravelAds(
    $context: ContextInput!
    $destination: DestinationInput!
    $rooms: [RoomInput!]
    $dateRange: PropertyDateRangeInput
    $sort: PropertySort
    $filters: PropertySearchFiltersInput
    $marketing: PropertyMarketingInfoInput
    $legacyCriteria: LegacyPropertySearchCriteriaInput
    $propertyShopOptions: PropertyShopOptionsInput
    $searchPagination: PaginationInput
    $searchIntent: SearchIntentInput
    $shoppingContext: ShoppingContextInput
    $criteria: PropertySearchCriteriaInput
) {
    propertySearch(
        context: $context
        destination: $destination
        rooms: $rooms
        dateRange: $dateRange
        sort: $sort
        filters: $filters
        marketing: $marketing
        legacyCriteria: $legacyCriteria
        propertyShopOptions: $propertyShopOptions
        searchPagination: $searchPagination
        searchIntent: $searchIntent
        shoppingContext: $shoppingContext
        criteria: $criteria
    ) {
        properties {
            id
            name
            amenities {
                icon
                name
            }
            propertyImage {
                image {
                    description
                    url
                }
                fallbackImage {
                    description
                    url
                }
                imageId
            }
            offerBadge {
                primary {
                    text
                    theme_temp
                    icon_temp {
                        id
                        description
                    }
                    mark {
                        id
                        description
                    }
                }
                secondary {
                    text
                    theme_temp
                    icon_temp {
                        id
                        description
                    }
                }
            }
            price {
                alignment
                displayMessages {
                    lineItems {
                        ... on DisplayPrice {
                            __typename
                            role
                            price {
                                formatted
                                accessibilityLabel
                            }
                            disclaimer {
                                content
                                primaryUIButton {
                                accessibility
                                primary
                                }
                            }
                        }
                        ... on LodgingEnrichedMessage {
                            __typename
                            value
                            state
                        }
                    }
                }
                lead {
                    formatted
                }
                strikeOutType
                strikeOut {
                    formatted
                }
                disclaimer {
                    value
                }
                roomNightMessage
                priceMessages {
                    value
                }
                marketingFeeDetails {
                    tierName
                    tierIcon
                    marketingFeeMessage {
                        value
                    }
                }
                options {
                    leadingCaption
                    displayPrice {
                        formatted
                    }
                    strikeOut {
                        formatted
                    }
                    loyaltyPrice {
                        amount {
                            formatted
                        }
                        totalStrikeOutPoints {
                            formatted
                        }
                        unit
                    }
                    disclaimer {
                        value
                    }
                }
            }
            reviews {
                score
                localizedScore
                total
                localizedTotal
                superlative
                localizedSubtitle
                localizedSubtitleA11y {
                    accessibilityLabel
                    value
                }
            }
            destinationInfo {
                distanceFromMessaging
            }
            vipMessaging
            infositeURL
            propertyDetailsLink {
                uri {
                    relativePath
                    value
                }
                clientSideAnalytics {
                    referrerId
                    linkName
                }
            }
            star
            starRatingIcon
            availability {
                available
                text
                theme
            }
            offerSummary {
                messages {
                    message
                    theme
                    type
                    mark {
                        id
                    }
                }
            }
            legalDisclaimer {
                title
                disclaimerContents
            }
            neighborhood {
                name
            }
            recentlyViewed {
                id
                description
            }
            supportingMessages
            shortList {
                favorited
                saveUrl
                removeUrl
                metaData {
                    chkIn
                    chkOut
                    hotelId
                    roomConfiguration
                }
            }
            sponsoredListing {
                id
                clickRedirectTrackingUrl
                clickTrackingUrl
                details
                detailsHeadline
                hotelImage
                impressionTrackingUrl
                trackingData
                brand
                clickRedirectLinkoffTrackingUrl
                logo
                lotagline
                rating
                slots
                vanityUrl
                rank
                position
            }
            highlightedPropertyDetails
            dataAttributes {
                key
                value
            }
        }
    }
}

    `;

    export const removeItemFromCartQuery = templateJoin`
        mutation RemoveItemFromCart($cartId: UUID!, $context: ContextInput!, $itemId: UUID!){
    cartItems(
        id: $cartId, context: $context
    ) {
        remove(id: $itemId) {
            id
            itemCount
        }
    }
}

    `;

    export const selectProductsQuery = templateJoin`
        mutation SelectProducts($context: ContextInput! $sessionId: String! $priceToken: String $properties: [PropertyNaturalKeyInput!] $flights: [FlightNaturalKeyInput!] $cars: [CarNaturalKeyInput!]) {
    multiItemShopping(context: $context) {
        selectProducts(sessionId: $sessionId priceToken: $priceToken properties: $properties flights: $flights cars: $cars) {
            __typename
            ... on MultiItemSearchContextCreatedResponse {
                shoppingContext {
                    multiItem {
                        id
                        packageType
                    }
                }
                redirectUrl
            }
            ... on MultiItemSearchContextErrorResponse {
                message
            }
        }
    }
}

    `;

